import { NgModule } from '@angular/core';
import { AbstractSecurityStorage, AuthModule } from 'angular-auth-oidc-client';
import { environment } from '@env/environment';
import { OidcStorageService } from './oidc-storage.service';
import { OidcConfigIds } from '@common/models/user-management.model';

@NgModule({
  imports: [
    AuthModule.forRoot({
      config: {
        configId: OidcConfigIds.XGS,
        authority: `https://${environment.xgsIdp}`,
        redirectUrl: `${window.location.origin}/authorize`,
        postLogoutRedirectUri: `${environment.xgsBaseURL}/sso/logout`,
        unauthorizedRoute: '/authorize',
        clientId: environment.xgsClientID,
        scope: 'openid email profile roles offline_access',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        renewUserInfoAfterTokenRenew: true,
        silentRenewUrl: `https://${environment.xgsIdp}/protocol/openid-connect/token`,
        ignoreNonceAfterRefresh: true,
        autoUserInfo: true,
        logLevel: environment.logLevel,
        renewTimeBeforeTokenExpiresInSeconds: 30,
        maxIdTokenIatOffsetAllowedInSeconds: 300,
        historyCleanupOff: false
      }
    })
  ],
    providers: [
    { provide: AbstractSecurityStorage, useClass: OidcStorageService }
  ],
  exports: [AuthModule]
})
export class AuthConfigModule {}
